import './polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import './theme.css'
import moment from 'moment'
moment.locale('ru')

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  store.dispatch('navigate', to)
  next()
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

const { version } = require('../package.json')
console.log(`v${version}`)
store.dispatch('connect', { router })
